import { API_BASE_URL } from "../../../config";

// Gateway prefix /imd/api/** rewrites to imd-module /api/**, so these hit /api/v1/imd/admin/*.
// Contract: docs in ~/.exa/briefs/imd-remote-control-contract.md (§ หน้าเว็บ manager).
const IMD_ADMIN_BASE = `${API_BASE_URL}/imd/api/v1/imd/admin`;

// type → label/description. destructive = ต้องพิมพ์ชื่อเครื่องยืนยัน (contract หลักการข้อ 4).
export const COMMAND_TYPES = {
    REQUEST_SNAPSHOT: {
        label: "ขอสถานะ",
        destructive: false,
        description: "เครื่องส่งสถานะปัจจุบันกลับมาทันที ไม่กระทบข้อมูลในเครื่อง",
    },
    FORCE_UPDATE: {
        label: "อัปเดตแอพทันที",
        destructive: false,
        description: "เช็คฟีด OTA แล้วติดตั้งทันที โดยข้ามเงื่อนไขขายอยู่/จอดับ/งานค้าง",
        warning: "ถ้าเครื่องกำลังขายอยู่ แอพจะถูกฆ่าทันที",
    },
    UPLOAD_LOG: {
        label: "ส่ง log",
        destructive: false,
        description: "ส่ง log ของเครื่องขึ้นทันที",
    },
    DELETE_OUTBOX_ITEMS: {
        label: "ลบงานค้าง",
        destructive: true,
        description: "ลบงานค้างออกจากคิวของเครื่อง งานที่กำลังบินจะไม่ถูกลบ",
    },
    CLEAR_LOCAL_ROUND: {
        label: "ลบกะในเครื่อง",
        destructive: true,
        description: "ล้างรอบ/กะที่ค้างอยู่ในโทรศัพท์เครื่องนี้ เครื่องจะกลับเป็น \"ยังไม่ได้เริ่มการขาย\" โดยไม่แจ้ง server",
    },
    CLOSE_SHIFT: {
        label: "จบกะ",
        destructive: true,
        description: "ทำเหมือนผู้ใช้กด \"จบกะ → ยืนยัน\" บนเครื่อง โดยไม่มีหน้าสรุป",
    },
    OPEN_SHIFT: {
        label: "เริ่มกะ (เลือกคนขับ)",
        destructive: true,
        description: "ทำเหมือนกด \"เริ่มการขาย + เลือกคนขับ\" บนเครื่อง ต้องไม่มีรอบที่เริ่มแล้ว",
    },
};

export const STATUS_LABEL = {
    PENDING: "รอส่งไปเครื่อง",
    SENT: "ส่งถึงเครื่องแล้ว รอทำ",
    DONE: "สำเร็จ",
    FAILED: "ล้มเหลว",
    SKIPPED: "เครื่องข้าม (ปฏิเสธ)",
    CANCELLED: "ยกเลิกแล้ว",
    EXPIRED: "หมดอายุ",
};

export const POLL_INTERVAL_MS = 5000;

export function getToken() {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        return user?.token || "";
    } catch { return ""; }
}

async function api(method, url, body) {
    const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!r.ok) {
        // server ส่งข้อความไทยมาตรง ๆ (409/404) — แสดงตามนั้น ไม่แปลงเอง
        const text = await r.text().catch(() => "");
        const err = new Error(text || `${r.status} ${r.statusText}`);
        err.status = r.status;
        throw err;
    }
    return r.status === 204 ? null : r.json();
}

export const listDevices = () => api("GET", `${IMD_ADMIN_BASE}/devices`);
// คืน { device, state, commands } (ไม่ unwrap — ผู้เรียกอ่านตามรูปนี้)
export const getDevice = (deviceId) => api("GET", `${IMD_ADMIN_BASE}/devices/${encodeURIComponent(deviceId)}`);
export const sendCommand = (deviceId, body) => api("POST", `${IMD_ADMIN_BASE}/devices/${encodeURIComponent(deviceId)}/commands`, body);
export const cancelCommand = (id) => api("POST", `${IMD_ADMIN_BASE}/commands/${encodeURIComponent(id)}/cancel`);

// รหัสยืนยันของเครื่อง: ชื่อสาย ถ้าไม่มีใช้ 6 ตัวท้ายของ deviceId (ตรงกับ server)
export function confirmTargetOf(device) {
    const label = device?.label?.trim();
    return label || (device?.deviceId || "").slice(-6);
}

// เวลาเป็น ICT เสมอ (ตามกฎ feedback_report_times_in_ict)
export function formatIct(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    // ปฏิทินคริสต์ศักราช (ไม่ใช้ พ.ศ.) ให้ตรงกับหน้าอื่นของ ICECYS
    return d.toLocaleString("th-TH-u-ca-gregory", { timeZone: "Asia/Bangkok", dateStyle: "short", timeStyle: "medium" });
}
